import apiClient from "./client";

export const getAccessories = async ({ language = "en" } = {}) => {
  const response = await apiClient.get("/accessories", {
    params: { language },
  });
  return response.data;
};

export const getAccessoryById = async ({ id, language = "en" }) => {
  const response = await apiClient.get(`/accessories/${id}`, {
    params: { language },
  });
  return response.data;
};

// Backward-compatible aliases while components are still named "metal".
export const getMetals = getAccessories;
export const getMetalById = getAccessoryById;
